export const FAVORITE_VIDEO = `
  mutation favoriteVideo($id: ID!) {
    favoriteVideo(id: $id)
  }
`;

export const UNFAVORITE_VIDEO = `
  mutation unFavoriteVideo($id: ID!) {
    unFavoriteVideo(id: $id)
  }
`;
